import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Popover } from 'react-tiny-popover';

import ThemeIcons from '../../theme/Icons';
import ThemeContext from '../../theme/ThemeContext';

import Button from './Button';

const StyledPopover = styled.div`
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: ${(props) => props.theme.borderRadius}px;
  border: 1px solid ${(props) => props.theme.borderColor};
  box-shadow: 0px 1px 10px 1px rgba(20, 20, 23, 0.35);
  font-family: ${(props) => props.theme.fontFamily};
  padding: 8px 0px;

`;

const StyledPopoverHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

`;

const StyledPopoverFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  transition: all 0.15s ease-in-out;
  margin: 0px 12px;

`;

const CustomPopover = ({
  isOpen,
  content,
  children,
  positions = ['top', 'bottom', 'left', 'right'], // preferred positions by priority
  reposition = false,
  onClose,
  onSubmit,
  onClickOutside
}) => {

  const theme = useContext(ThemeContext);

  return (
    <Popover
      reposition={reposition}
      isOpen={isOpen}
      positions={positions}
      containerStyle={{ zIndex: 10000, borderRadius: 8 }}
      onClickOutside={onClickOutside}
      content={(
        <StyledPopover theme={theme}>
          {!onClose ? null : (
            <StyledPopoverHeader>
              <Button
                danger
                styles={{ padding: '2px 4px', marginRight: '4px' }}
                icon={ThemeIcons.misc.close}
                onClick={onClose}
              />
            </StyledPopoverHeader>
          )}
          {content}
          {!onSubmit ? null : (
            <StyledPopoverFooter>
              <Button
                styles={{ marginLeft: '4px' }}
                icon={ThemeIcons.misc.submit}
                onClick={onSubmit}
              />
            </StyledPopoverFooter>
          )}
        </StyledPopover>
      )}
    >
      {children}
    </Popover>
  );

};

CustomPopover.propTypes = {
  isOpen: PropTypes.bool,
  positions: PropTypes.array,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  onClickOutside: PropTypes.func,
};

export default CustomPopover;
